




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/*
  修改信息根据id获取到当前得伤情信息数据遍历
*/
import { Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import Component from 'vue-class-component'
import {
  addtopic,
  gettopicinfo,
  addtopicdata,
  updatetopic,
  updateinfo,
  gettableinfo,
  addmajor,
  getmajorinfo,
  adddesign,
  getdesigninfo,
  addbasics,
  getbasicsinfo,
  addyqyjcg,
  getyqyjcginfo,
  addjfgl,
  getjfglinfo,
  addndktlz,
  getndktlzinfo,
  uploadzsxg,
  addbudget,
  getbudgetinfo,
  addopinion,
  getopinioninfo,
  getcertificateinfo,
  updateuploadfile,
  downloadfile,
  downloadPDF,
  getktsjinfo,
  updatetopicfile,
  getguidlist
} from '@/api/declare'
import $ from 'jquery'
import '../../../public/ueditor/ueditor.config.js'
import './../../../public/ueditor/ueditor.all.js'
import '../../../public/ueditor/lang/zh-cn/zh-cn.js'
import VueUeditorWrap from 'vue-ueditor-wrap'
import { connect } from 'echarts'
import { Console } from 'console'

@Component({
  name: 'equipManage',
  components: { VueUeditorWrap }
})
export default class extends Vue {
  /*
    修改信息根据id获取到当前得伤情信息数据遍历
  */
  created() {
    this.citylist = require('./../../../public/city.json')
    this.grouplist = require('./../../../public/group.json')
    this.dqyear = JSON.parse(window.sessionStorage.getItem('time') as any)
    let showxg = JSON.parse(window.sessionStorage.getItem('isrefuse') as any)
    if (showxg) {
      this.isrefuse = true;
      this.allyearnum.columns = [
        { field: 'year', title: '年份', width: '750px' },
        { field: 'money', title: '金额（万元）' },
        { field: 'money1', title: '调整金额（万元）' }
      ]
    } else {
      this.isrefuse = false;
      this.allyearnum.columns = [
        { field: 'year', title: '年份', width: '750px' },
        { field: 'money', title: '金额（万元）' }
      ]
    }
  }

  mounted() {
    // this.copetabledata = JSON.parse(JSON.stringify(this.dataForm));
    // 判断topicid.topicId存在是编辑 topicid存在是新增
    let topicparam = window.sessionStorage.getItem('topicid') as any
    //andy
    //this.getguidelist()
    let iswatch = window.sessionStorage.getItem('iswatch') as any
    let isedit = window.sessionStorage.getItem('iseditys') as any
    let ishandle = window.sessionStorage.getItem('ishandle')

    this.userleavel = JSON.parse(
      window.sessionStorage.getItem('topicinfo') as any
    ).level
    if (this.userleavel != null || this.userleavel !== '') {
      this.agreeform.level = this.userleavel
    }

    this.baseurl = (window as any).downloadurl
    this.basedownloadurl = (window as any).baseurl

    $('.el-upload--picture-card').css({ display: 'none' })
    if (JSON.parse(topicparam).topicId) {
      this.getguidelist(true)
      this.topicid = JSON.parse(topicparam).topicId
      if (this.topicid) {
        this.gettabledatinfo()
        if (iswatch != null) {
          $('.iseditys').css({ 'pointer-events': 'none' })
          this.iswatch = false
          if (ishandle != null) {
            this.ishandlebtn = true
          } else {
            this.ishandlebtn = false
          }
        } else if (this.isrefuse !== null) {
          this.iseditys = false
          $('.iseditys').css({ 'pointer-events': 'none' })
        }
      }
    } else if (JSON.parse(topicparam)) {
      this.getguidelist(false)
      this.topicid = JSON.parse(topicparam)
      if (this.topicid) {
        this.gettabledatinfo()
        if (iswatch != null) {
          $('.iseditys').css({ 'pointer-events': 'none' })
          this.iswatch = false
          if (ishandle != null) {
            this.ishandlebtn = true
          } else {
            this.ishandlebtn = false
          }
        } else if (this.isrefuse != null) {
          this.iseditys = false
          $('.iseditys').css({ 'pointer-events': 'none' })
        }
      }
    }
  }
  private activeName = '数据表'
  private uploadid = ''
  private dqyear = ''
  private baseurl = ''
  private basedownloadurl = ''
  private iswatch = true
  private iseditys = true
  private isrefuse = false
  private iseditys1 = false
  private userleavel: any = ''
  private ishandlebtn = false
  private isystg = false
  private ktloading = false
  private ktloadingtitle = ''
  private copetabledata = {} //克隆得数据表
  private copepricdata = [] //克隆的负责人表，预期研究成果，经费管理，
  private copejfys = {}
  private copefilelist = []
  private copeobj = '' //克隆的课题设计论证，研究基础及条件，单位意见，课题论证活页
  // tabs标签得配置项
  private tabsobj = {
    name: '',
    isshow: false
  };
  private topicid: any = ''
  private uploadData = [];
  // 监听页面数据项是否发生变化
  private tabsbool: any = [
    { key: '数据表', isshow: false },
    { key: '负责人', isshow: false },
    { key: '相关证书', isshow: false },
    { key: '课题设计论证', isshow: false },
    { key: '研究基础及条件', isshow: false },
    { key: '预期研究成果', isshow: false },
    { key: '经费预算', isshow: false },
    { key: '经费管理', isshow: false },
    { key: '单位意见', isshow: false },
    { key: '课题论证活页', isshow: false },
    { key: '提交课题', isshow: false }
  ];
  private chooseclass = [
    {
      label: '中医药人才考试评价指数研究',
      value: '中医药人才考试评价指数研究'
    },
    {
      label: '中医药整合型试题的研究与开发',
      value: '中医药整合型试题的研究与开发'
    },
    {
      label: '中医思维评价量表设计与实证研究',
      value: '中医思维评价量表设计与实证研究'
    },
    {
      label: '中医思维训练考核模式创新性研究',
      value: '中医思维训练考核模式创新性研究'
    },
    {
      label: '中医临床技能操作训练与考核标准化研究',
      value: '中医临床技能操作训练与考核标准化研究'
    },
    {
      label: '中医类别医师资格考试考务目标管理实证研究',
      value: '中医类别医师资格考试考务目标管理实证研究'
    },
    {
      label: '实践技能考试中医特色示范基地建设标准研究',
      value: '实践技能考试中医特色示范基地建设标准研究'
    },
    {
      label: '中医药外向型人才培养基地建设标准研究',
      value: '中医药外向型人才培养基地建设标准研究'
    },
    {
      label: '中医疫病防治医师队伍准入路径研究',
      value: '中医疫病防治医师队伍准入路径研究'
    },
    {
      label: '基层中医药人才能力评价体系研究',
      value: '基层中医药人才能力评价体系研究'
    },
    {
      label: '中药人才传承教育的管理评价体系研究',
      value: '中药人才传承教育的管理评价体系研究'
    },
    { label: '中医经典能力考核体系研究', value: '中医经典能力考核体系研究' },
    {
      label: '中医药行业职业技能竞赛机制研究',
      value: '中医药行业职业技能竞赛机制研究'
    },
    {
      label: '标准化病人（SP）在中医住院医师规范化培训考核体系中的应用研究',
      value: 14
    },
    { label: '中医药国际化人才能力考核体系研究', value: 15 },
    { label: '中医药考试全流程信息化研究', value: 16 }
  ];
  private ruleForm: any = {
    filelist: [],
    fileid: '',
    visible: false,
  };
  private agreeform: any = {
    level: '',
    agreevis: false,
    descri: '',
    fund: '',
    refusevis: false, // 驳回
    refuseysvis: false, // 经费预算驳回
    xswtgVis: false, // 形审未通过
    xswtgDesc: '' // 形审未通过绑定的值
  };
  private jfysForm: any = {
    account: '',
    bank: '',
    id: '',
    payee: '',
    phone: '',
    state: 3,
    place: '',
    topicid: '',
  };
  private dataForm: any = {
    administrative: '', // 行政职务
    administrative2: '', // 第二负责人行政职务
    birthday: '', // 出生日期
    birthday2: '', // 第二出生日期
    // 协助单位集合
    cooperativeInfoList: [
      // {
      //   contacts: "",
      //   id: "",
      //   num: "",
      //   phone: "",
      //   property: "",
      //   workname: "",
      // },
    ],
    guideid: '', // 中心选题数据
    id: '', // 数据表id
    level: '', // 层级
    num: '',
    state: '', // 课题状态
    topictype: '0', // 选题方向 0中心选题 1自主选题
    updatetime: '',
    userId: '',
    degree: '', // 学位
    degree2: '', // 学位2
    donetime: '', // 预计完成时间 ,
    educationbg:  '', // 学历
    educationbg2: '', // 学历2
    email: '', // 邮箱
    email2: '', // 邮箱2
    expenditure: 0, // 申请自主经费（单位：万元）
    finalresult: '', // 预期最终结果
    headname: '', // 负责人姓名
    headname2: '', // 负责人姓名2
    identity: '', // 身份证
    identity2: '', // 身份证2
    job: '', // 专业职务
    job2: '', // 专业职务2
    keyword: '', // 关键字
    nation: '', // 名族
    nation2: '', // 名族2
    phone: '', // 联系电话
    phone2: '', // 联系电话2
    postcode: '', // 邮编
    postcode2: '', // 邮编2
    provincename: '', // 所在省
    provincename2: '', // 所在省2
    provincenum: '', // 所在省编号
    provincenum2: '', // 所在省编号2
    rolename: '', // 担任导师名称
    rolename2: '', // 担任导师名称2
    rolenum: '', // 担任导师编号
    rolenum2: '', // 担任导师编号2
    sex: 0, // 性别
    sex2: 0, // 性别2
    speciality: '', // 研究专长
    speciality2: '', // 研究专长2
    systemname: '', //  所属系统名称
    systemname2: '', // 所属系统名称2
    systemnum: '', // 所属系统编号
    systemnum2: '', // 所属系统编号2
    // 主要参与者集合
    topicdatadetailList: [
      // {
      //   degree: "", //学位
      //   educationbg: "", //学历
      //   id: "", //id
      //   job: "", //专业职务
      //   name: "", //姓名
      //   phone: "", //联系方式
      //   speciality: "", //研究专长
      //   work: "", //工作单位
      // },
    ],
    topicid: '', // 课题id
    topicname: '', // 课题名称
    work: '', // 工作单位
    work2: '', // 第二负责人工作单位
    workaddress: '', // 工作单位通讯地址
    workaddress2: '' // 工作单位通讯地址
  };
  private tabledataobj = {
    systeminput: '',
    cityinput: '',
    projectisshow: true, // 课题方向是否显示
    personshow: false, // 第二负责人填写是否显示
    sylength: 7000, // 富文本框剩余输入字数
  };
  private uploadobj: any = {
    visible: false,
    fileSizeIsSatisfy: []
  };
  private ysuploadData: any = [];
  private tableissave = false; // 保存按钮是否显示
  private tableCellClickRowIndex: any = null; // 点击的单元格行索引
  private tableCellClickColumnIndex: any = null; // 点击的单元格列索引
  // 参与者列表数据源
  private datatable: any = {
    sel: null, // 选中行
    columns: [
      { field: 'name', title: '姓名' },
      { field: 'burndate', title: '出生年月' },
      { field: 'job', title: '专业职务' },
      { field: 'speciality', title: '研究专长' },
      { field: 'educationbg', title: '学历' },
      { field: 'degree', title: '学位' },
      { field: 'work', title: '工作单位' },
      { field: 'phone', title: '联系方式' }
    ],
    data: []
  };
  // 协作单位数据源
  private partner: any = {
    sel: null, // 选中行
    columns: [
      { field: 'workname', title: '单位名称' },
      { field: 'property', title: '单位性质' },
      { field: 'contacts', title: '联系人' },
      { field: 'phone', title: '联系方式' }
    ],
    data: []
  };
  // 负责人数据源
  private principal: any = {
    sel: null, // 选中行
    columns: [
      { field: 'host', title: '主持人' },
      { field: 'topicname', title: '课题名称' },
      { field: 'topiclevel', title: '课题级别' },
      { field: 'authorizetime', title: '批准时间' },
      { field: 'authorizeorganization', title: '批准单位' },
      { field: 'situation', title: '完成情况' }
    ],
    data: [],
  };
  // 年度经费预算金额
  private allyearnum: any = {
    sel: null, // 选中行
    columns: [
      { field: 'year', title: '年份' },
      { field: 'money', title: '金额（万元）' }
    ],
    data: []
  };
  // 经费预算数据源
  private budgetdata: any = {
    sel: null, // 选中行
    id: '',
    idupdate: '', // 驳回预算后得重新提交得id
    columns: [
      { field: 'expense', title: '经费开支项目' },
      { field: 'money', title: '金额（万元）' }
    ],
    data: [
      {
        id: '',
        expense: '办公费',
        money: '0',
        money1: '0',
        description: '反映单位购买日常办公用品、书报杂志等支出'
      },
      {
        id: '',
        expense: '印刷费',
        money: '0',
        money1: '0',
        description: '反映单位的印刷费支出',
      },
      {
        id: '',
        expense: '咨询费',
        money: '0',
        money1: '0',
        description: '反映单位咨询方面的支出',
      },
      {
        id: '',
        expense: '邮电费',
        money: '0',
        money1: '0',
        description:
          '反映单位开支的信函、包裹、货物等物品的邮寄费及电话费、电报费、传真费、网络通讯费等'
      },
      {
        id: '',
        expense: '差旅费',
        money: '0',
        money1: '0',
        description:
          '反映单位工作人员国（境）内出差发生的城市间交通费、住宿费、伙食补助费和市内交通费'
      },
      {
        id: '',
        expense: '会议费',
        money: '0',
        money1: '0',
        description:
          '反映单位在会议期间按规定开支的住宿费、伙食费、会议场地租金、交通费、文件印刷费、医药费等'
      },
      {
        id: '',
        expense: '培训费',
        money: '0',
        money1: '0',
        description:
          '反映除因公出国（境）培训费以外的，在培训期间发生的师资费、住宿费、伙食费、培训场地费、培训资料费、交通费等各类培训费用'
      },
      {
        id: '',
        expense: '劳务费',
        money: '0',
        money1: '0',
        description:
          '反映支付给外单位和个人的劳务费用，如临时聘用人员、钟点工工资、稿费、翻译费、评审费等',
      },
      {
        id: '',
        expense: '其他商品和服务支出',
        money: '0',
        money1: '0',
        description:
          '反映上述科目未包括的日常公用支出。如诉讼费、国内组织的会员费、来访费、广告宣传费以及离休人员特需费、离退休人员公用经费等',
      }
    ],
    ptdata: [
      {
        id: '',
        money: '0',
        money1: '0'
      },
    ],
    hjdata: [
      {
        money: '0',
        money1: '0'
      }
    ]
  };
  // 预期研究成果数据源
  private expecteddata: any = {
    sel: null, // 选中行
    columns: [
      { field: 'finishtime', title: '完成时间' },
      { field: 'researchname', title: '最终成果名称' },
      { field: 'researchstyle', title: '成果形式' },
      { field: 'proctor', title: '负责人' }
    ],
    data: []
  };
  private zyzwlist = [
    {
      label: '教授',
      value: '教授'
    },
    {
      label: '副教授',
      value: '副教授'
    },
    {
      label: '讲师',
      value: '讲师'
    },
    {
      label: '助理讲师',
      value: '助理讲师',
    },
    {
      label: '研究员',
      value: '研究员'
    },
    {
      label: '副研究员',
      value: '副研究员'
    },
    {
      label: '助理研究员',
      value: '助理研究员'
    },
    {
      label: '研究实习员',
      value: '研究实习员'
    },
    {
      label: '主任医师',
      value: '主任医师'
    },
    {
      label: '副主任医师',
      value: '副主任医师'
    },
    {
      label: '主治（主管）医师',
      value: '主治（主管）医师'
    },
    {
      label: '医师、医士',
      value: '医师、医士'
    },
    {
      label: '主任药师',
      value: '主任药师'
    },
    {
      label: '副主任药师',
      value: '副主任药师'
    },
    {
      label: '副主任药师',
      value: '副主任药师'
    },
    {
      label: '主管药师',
      value: '主管药师'
    },
    {
      label: '药师、药士',
      value: '药师、药士'
    },
    {
      label: '主任护师',
      value: '主任护师'
    },
    {
      label: '副主任护师',
      value: '副主任护师',
    },
    {
      label: '护师、护士',
      value: '护师、护士'
    },
    {
      label: '主任技师',
      value: '主任技师'
    },
    {
      label: '副主任技师',
      value: '副主任技师'
    },
    {
      label: '主管技师',
      value: '主管技师'
    },
    {
      label: '技师、技士',
      value: '技师、技士',
    },
    {
      label: '教授级高级工程师',
      value: '教授级高级工程师'
    },
    {
      label: '高级工程师',
      value: '高级工程师',
    },
    {
      label: '工程师',
      value: '工程师'
    },
    {
      label: '助理工程师、技术员',
      value: '助理工程师、技术员'
    },
    {
      label: '其它',
      value: '其它',
    }
  ];
  // 所属系统数组
  private systemlist = [
    {
      label: 'A.考区考点',
      value: 'A.考区考点'
    },
    {
      label: 'B.高校',
      value: 'B.高校'
    },
    {
      label: 'C.医院',
      value: 'C.医院'
    },
    {
      label: 'D.科研院所',
      value: 'D.科研院所'
    },
    {
      label: 'E.中医药行业学会',
      value: 'E.中医药行业学会'
    },
    {
      label: 'F.大型企业',
      value: 'F.大型企业'
    },
    {
      label: 'G.其它',
      value: 'G.其它'
    }
  ];
  // 最高学历数组
  private learnlist = [
    {
      label: '本科',
      value: '本科'
    },
    {
      label: '硕士研究生',
      value: '硕士研究生'
    },
    {
      label: '博士研究生',
      value: '博士研究生'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];
  private degreelist = [
    {
      label: '学士',
      value: '学士'
    },
    {
      label: '硕士',
      value: '硕士'
    },
    {
      label: '博士',
      value: '博士'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];
  private grouplist = [];
  private citylist = [];
  private rules = {};
  //
  private editor = {
    id: '',
    content: '',
    topicName: '',
    yjjccontent: '',
    dayjcontent: '',
    ndktcontent: '',
    dwyjcontent: '',
  };
  private submitform() {
    let addparam: any = window.sessionStorage.getItem('topicinfo')
    if (this.uploadData.length === 0) {
      this.$message.warning('请上传附件')
    } else {
      let upaddparm = JSON.parse(addparam)

      let updateparam = {
        guideid: upaddparm.guideid,
        id: upaddparm.id,
        isdelete: upaddparm.isdelete,
        level: upaddparm.level,
        num: upaddparm.num,
        state: '0',
        topicName: upaddparm.name,
        topictype: upaddparm.topictype,
        updatetime: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
        userId: upaddparm.userid
      }

      updatetopic(updateparam).then((res) => {
        if (res.code === 200) {
          this.$message.success('课题提交成功')
        }
      })
    }
  }
  // unditor加载完成
  private UEeditorready(editor) {
    editor.setDisabled()
  }
  private ueConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 595,

    // 初始容器宽度
    initialFrameWidth: 567,
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    serverUrl: '',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli2.0 生成的项目，通常不需要设置该选项，默认是：UEDITOR_HOME_URL: '/static/UEditor/'
    // 但是 vue cli 3.x 生成的项目中，默认值是 process.env.BASE_URL + 'UEditor/'，如果项目不是部署在根目录下，则需要自己配置路径，我的项目是在根目录下，手动下载的UEditor放在了public目录下
    UEDITOR_HOME_URL: "/ueditor/",
    // 自定义菜单
    toolbars: [
      [
        'undo', // 撤销
        'redo', // 重做
        'underline', // 下划线
        "strikethrough", // 删除线
        "fontborder", // 字符边框
        "source", // 源代码
        "subscript", // 下标
        "superscript", // 上标
        "formatmatch", // 格式刷
        "selectall", // 全选
        "preview", // 预览
        "horizontal", // 分隔线
        "cleardoc", //清空文档
        "indent", //首行缩进
        "bold", //加粗
        "italic", //斜体
        "fontfamily", //字体
        "fontsize", //字号
        "paragraph", //段落格式
        "pagebreak", //分页
        "insertframe", //插入Iframe
        "searchreplace", //查询替换
        "justifyleft", //居左对齐
        "justifyright", //居右对齐
        "justifycenter", //居中对齐
        "justifyjustify", //两端对齐
        "forecolor", //字体颜色
        "backcolor", //背景色
        "insertorderedlist", //有序列表
        "insertunorderedlist", //无序列表
        "fullscreen", //全屏
        "directionalityltr", //从左向右输入
        "directionalityrtl", //从右向左输入
        "rowspacingtop", //段前距
        "rowspacingbottom", //段后距
        "imagenone", //默认
        "imageleft", //左浮动
        "imageright", //右浮动
        "attachment", //附件
        "imagecenter", //居中
        "lineheight", //行间距
        "edittip ", //编辑提示
        "customstyle", //自定义标题
        "autotypeset", //自动排版
        "tolowercase", //字母小写
        "inserttable", //插入表格
        "charts", // 图表
      ],
    ],
  };
  returnWaring(activeName, oldActiveName) {
    return this.$confirm(
      "离开将不保存" + oldActiveName + "页修改,请先暂存数据",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(() => {
        this.tabsbool.forEach((res, index) => {
          if (oldActiveName == res.key) {
            res.isshow = false;
            let topicparam = window.sessionStorage.getItem("topicid") as any;
            let index_;
            // if topicparam.topicId存在是编辑  不存在是新增
            if (JSON.parse(topicparam).topicId) {
              this.getdataslist(activeName);
              for (let i in this.tabsbool) {
                if (oldActiveName == this.tabsbool[i].key) {
                  index_ = i;
                }
              }
              // this.emptydeclare(index_);
            } else {
              for (let i in this.tabsbool) {
                if (oldActiveName == this.tabsbool[i].key) {
                  index_ = i;
                }
              }
              // this.emptydeclare(index_);
            }
          }
        });
      })
      .catch(() => {
        throw new Error("取消成功！");
      });
  }
  leaveTabs(activeName, oldActiveName) {
    for (let i in this.tabsbool) {
      if (oldActiveName == this.tabsbool[i].key) {
        if (this.tabsbool[i].isshow) {
          return this.returnWaring(activeName, oldActiveName);
        } else {
          this.getdataslist(activeName);
        }
      }
    }
  }
  // 获取经费管理
  getjfgl() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    getjfglinfo(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          this.jfysForm = res.data;
        }
      }
    });
  }
  getdataslist(activeName) {
    if (activeName == "负责人") {
      this.getprincipalinfo(getmajorinfo, "principal");
    } else if (activeName == "课题设计论证") {
      this.getobjsinfo(getdesigninfo, "content");
    } else if (activeName == "研究基础及条件") {
      this.getobjsinfo(getbasicsinfo, "yjjccontent");
    } else if (activeName == "预期研究成果") {
      this.getprincipalinfo(getyqyjcginfo, "expecteddata");
    } else if (activeName == "经费预算") {
      this.getbudgetinfo();
    } else if (activeName == "经费管理") {
      this.getjfgl();
    } else if (activeName == "单位意见") {
      this.getobjsinfo(getopinioninfo, "dwyjcontent");
    } else if (activeName == "课题论证活页") {
      this.getobjsinfo(getndktlzinfo, "ndktcontent");
    } else if (activeName == "数据表") {
      this.gettabledatinfo();
    } else if (activeName == "相关证书") {
      this.getciterinfo();
    } else if (activeName == "提交课题") {
      this.getktlzsj();
    }
  }
  handleClick(val, index) {}
  private getguidelist(isUpdate) {
    let param = {
      content: "",
      isuse: 1,
      limit: 1,
      page: 1,
    };
    if(isUpdate){
      param.isuse = 2
    }
    getguidlist(param).then((res) => {
      if (res.code === 200) {
        let data = res.data.itemBeanList[0][0].itemBeanList;
        data.forEach((res) => {
          let obj: any = {
            label: res.content,
            value: res.id,
          };
          this.chooseclass.push(obj);
        });
      }
    });
  }
  changesystem(val) {
    this.tabledataobj.systeminput = val;
  }
  changecity(val) {
    this.tabledataobj.cityinput = val;
  }
  changeradio(val) {
    if (val == "0") {
      this.tabledataobj.projectisshow = true;
      this.dataForm.guideid = "";
    } else {
      this.tabledataobj.projectisshow = false;
    }
  }
  // 折叠填写负责人
  showsecondper() {
    if (!this.tabledataobj.personshow) {
      this.tabledataobj.personshow = true;
    } else {
      this.$confirm("如果折叠将会导致您所填的信息情况, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tabledataobj.personshow = false;
          this.dataForm.administrative2 = "";
          this.dataForm.birthday2 = "";
          this.dataForm.degree2 = "";
          this.dataForm.email2 = "";
          this.dataForm.headname2 = "";
          this.dataForm.identity2 = "";
          this.dataForm.job2 = "";
          this.dataForm.nation2 = "";
          this.dataForm.phone2 = "";
          this.dataForm.postcode2 = "";
          this.dataForm.provincename2 = "";
          this.dataForm.provincenum2 = "";
          this.dataForm.rolenum2 = "";
          this.dataForm.sex2 = 0;
          this.dataForm.speciality2 = "";
          this.dataForm.systemname2 = "";
          this.dataForm.systemnum2 = "";
          this.dataForm.work2 = "";
          this.dataForm.workaddress2 = "";
        })
        .catch(() => {});
    }
  }
  tableCellClick(row, column, cell, event) {
    this.tableCellClickRowIndex = row.index;
    this.tableCellClickColumnIndex = column.index;
  }
  /****-----------------表格输入框处理方法开始------------------------*****/
  readMasterUser(dataresouce) {
    //根据实际情况，自己改下啊
    this[dataresouce].data.map((i) => {
      i.id = i.id; //模拟后台插入成功后有了id
      i.isset = false; //给后台返回数据添加`isset`标识
      return i;
    });
  }
  //添加表格输入框input数据
  addMasterUser(dataresouce: any) {
    for (let i of this[dataresouce].data) {
      if (i.isset) return this.$message.warning("请先保存当前编辑项");
    }
    let j = {};
    if (dataresouce) {
      if (dataresouce !== "allyearnum") {
        if (this[dataresouce].data.length > 19) {
          this.$message.warning("当前最多添加20条");
          return false;
        }
      } else {
        if (this[dataresouce].data.length > 4) {
          this.$message.warning("年度经费预算最多允许添加5条");
          return false;
        }
      }
    }

    //datasource接收的是表格绑定的数据源名称,根据datasource判断push的对象格式
    if (dataresouce == "datatable") {
      j = {
        id: new Date().getTime(),
        name: "",
        burndate: "",
        job: "",
        speciality: "",
        educationbg: "",
        degree: "",
        work: "",
        phone: "",
        isset: true,
      };
    } else if (dataresouce == "partner") {
      j = {
        id: new Date().getTime(),
        workname: "",
        property: "",
        fete: "",
        contacts: "",
        phone: "",
        num: "",
        isset: true,
      };
    } else if (dataresouce == "principal") {
      j = {
        id: new Date().getTime(),
        host: "",
        topicname: "",
        topiclevel: "",
        authorizetime: "",
        authorizeorganization: "",
        situation: "",
        isset: true,
      };
    } else if (dataresouce == "expecteddata") {
      j = {
        id: new Date().getTime(),
        finishtime: "",
        researchname: "",
        researchstyle: "",
        proctor: "",
        isset: true,
      };
    } else if (dataresouce == "allyearnum") {
      j = {
        id: new Date().getTime(),
        expense: "",
        money: "",
        isset: true,
      };
    }
    this[dataresouce].data.push(j);
    this[dataresouce].sel = JSON.parse(JSON.stringify(j));
  }
  //修改表格输入框
  personChange(dataresouce, row, index, cg) {
    //点击修改 判断是否已经保存所有操作
    for (let i of this[dataresouce].data) {
      if (i.isset && i.id != row.id) {
        this.$message.warning("请先保存当前编辑项");
        return false;
      }
    }
    //是否是取消操作

    if (!cg) {
      if (String(this[dataresouce].sel.id).length === 13) {
        let copesource = _.clone(this[dataresouce].sel);
        delete copesource.id;
        for (let i in copesource) {
          if (copesource[i] === true) {
            this[dataresouce].data.splice(index, 1);
            return (row.isset = !row.isset);
          } else {
          }
        }
      }

      // this[dataresouce].data.splice(index, 1);
    }
    //提交数据
    if (row.isset) {
      if (this[dataresouce].data.length > 20) {
        this.$message.warning("当前最多添加20个");
      } else {
        //项目是模拟请求操作  自己修改下
        let data = JSON.parse(JSON.stringify(this[dataresouce].sel));
        for (let k in data) row[k] = data[k];
        //然后这边重新读取表格数据
        this.readMasterUser(dataresouce);
        row.isset = false;
      }
    } else {
      this[dataresouce].sel = JSON.parse(JSON.stringify(row));
      row.isset = true;
    }
  }

  // 删除表格输入框input表格方法
  handledelete(dataresouce, index) {
    this.$confirm("确定删除这条数据吗, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this[dataresouce].data.splice(index, 1);
      })
      .catch(() => {});
  }
  /****-----------------表格输入框处理方法结束------------------------*****/
  beforeAvatarUpload(file) {
    const isJPG = file.type === "image/jpeg";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传头像图片只能是 JPG 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }
  // 文件上传方法
  fileOnChange(file: any, fileList) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    const filelength = fileList.length;
    if (!isLt2M) {
      this.$message.warning("上传图片大小不能超过 2M!");
      fileList.splice(-1, 1); //移除选中图片
      return false;
    } else {
      this.uploadobj.fileSizeIsSatisfy.push(file);
    }
  }
  handleClose() {
    this.uploadobj.visible = false
    this.agreeform.agreevis = false
    this.agreeform.refusevis = false
    this.agreeform.refuseysvis = false
  }
  handleClosetopic() {
    this.ruleForm.visible = false;
  }
  handlePictureCardPreview(file) {
    this.uploadobj.visible = true;
    this.uploadobj.url = file.url;
  }

  // 修改经费预算属性
  editProperty(row, index, data_) {
    // 我这边是表格数据都是前端处理，需要把旧值存起来，用户点击修改之后修改了原来的数据，但是又点了取消的情况，还需要获取到原来的值
    sessionStorage.setItem("oldPropertValue", row.money);
    // // money为ture展示输入框
    this.$set(data_[index], "isEditPropertyShow", true);
  }
  // 保存经费预算属性
  saveProperty(row, index, data_, type) {
    this.$set(data_[index], "isEditPropertyShow", false);
    let money_: number = 0;
    let money1_: number = 0;
    this.budgetdata.data.forEach((res) => {
      money_ += Number(res.money);
    });
    money_ += Number(this.budgetdata.ptdata[0].money);
    this.budgetdata.hjdata[0].money = money_;
    // 调整预算时候
    if (!this.iseditys) {
      this.budgetdata.data.forEach((res) => {
        money1_ += Number(res.money1);
      });
      money1_ += Number(this.budgetdata.ptdata[0].money1);
      this.budgetdata.hjdata[0].money1 = money1_;
    }
  }
  // 取消经费预算属性
  cancelProperty(row, index, data_) {
    if (sessionStorage.getItem("oldPropertValue") !== "null") {
      this.$set(
        data_[index],
        "money",
        sessionStorage.getItem("oldPropertValue")
      );
    } else {
      this.$set(data_[index], "money", "");
    }
    this.$set(data_[index], "isEditPropertyShow", false);
  }
  // 显示富文本框剩余字数
  descInput() {
    // this.tabledataobj.sylength = 7000 - texval;
  }
  handleRemove(file, filelist) {
    this.uploadobj.fileSizeIsSatisfy = filelist;
  }
  // 暂存数据表内容
  savedatatable() {
    // 0待审核 1审核通过 2已撤回 3未提交 4驳回预算 5驳回

    if (this.datatable.data.length != 0) {
      this.datatable.data.forEach((res) => {
        if (String(res.id).length == 13) {
          res.id = "";
        }
        res.isset = 0;
      });
    }
    if (this.partner.data.length != 0) {
      this.partner.data.forEach((res) => {
        if (String(res.id).length == 13) {
          res.id = "";
        }
        res.isset = 0;
      });
    }
    this.dataForm.topicdatadetailList = this.datatable.data;
    this.dataForm.cooperativeInfoList = this.partner.data;
    this.dataForm.isdelete = 0;
    let params: any = window.sessionStorage.getItem("json");
    let params_: any = window.sessionStorage.getItem("topicid");
    this.dataForm.userId = JSON.parse(params).data.id;
    if (JSON.parse(params_).topicId) {
      this.dataForm.topicid = JSON.parse(params_).topicId;
    } else {
      this.dataForm.topicid = JSON.parse(params_);
    }

    this.dataForm.state = 3; //暂存得数据状态是3

    (this.$refs.dataForm as any).validate((valid) => {
      if (valid) {
        updateinfo(this.dataForm).then((res) => {
          if (res.code === 200) {
            this.$message.success("数据表数据暂存成功")
            this.tabsbool[0].isshow = false
          }
        })
      } else {
        return false
      }
    })
  }
  downfile(type) {
    let formadata = new FormData();
    formadata.append("topicId", this.topicid);
    if (type == 0) {
      downloadfile(formadata).then((res) => {
        if (res.code == 200) {
          let href = this.baseurl + "/topicdatadetail/exp/outWord/1";
          const savea = document.createElement("a");
          // savea.download = "已填写的申报内容";
          savea.setAttribute("download", "下载内容");
          savea.href = href;
          savea.click();
        }
      });
    } else {
      downloadfile(formadata).then((res) => {
        if (res.code == 200) {
          let href = this.baseurl + "/topicdatadetail/exp/outWord/2";
          const savea = document.createElement("a");
          savea.innerText = "已填写的申报内容";
          savea.href = href;
          savea.click();
        }
      });
    }
  }
  // 暂存相关证书
  savexgzs() {
    let formdata: any = new FormData();
    let topiciid = "";
    let params_: any = window.sessionStorage.getItem("topicid");
    let newarr: any = [];
    let paramarr: any = [];
    let content = "";
    if (JSON.parse(params_).topicId) {
      topiciid = JSON.parse(params_).topicId;
    } else {
      topiciid = JSON.parse(params_);
    }
    if (this.uploadobj.fileSizeIsSatisfy.length == 0) {
      this.$message.warning("当前未导入图片");
    } else {
      this.uploadobj.fileSizeIsSatisfy.forEach((res) => {
        if (res.raw) {
          formdata.append("file", res.raw);
        } else {
          newarr.push(res);
        }
      });
      newarr.forEach((res) => {
        let index = res.url.indexOf("=");
        let index_ = res.url.indexOf("&");

        paramarr.push(res.url.substring(index + 1, index_));
      });
      // 更新

      if (content.length != 0) {
        let param = {
          id: this.uploadid,
          content: content,
        };
        updateuploadfile(param).then((res) => {
          if (res.code === 200) {
            formdata.append("tableType", 0);
            formdata.append("topicId", topiciid);
            formdata.append("state", 3);
            formdata.append("id", this.uploadid);

            uploadzsxg(formdata).then((res) => {
              if (res.code == 200) {
                this.$message.success("证书上传成功");
                this.tabsbool[2].isshow = false;
              }
            });
          }
        });
      } else {
        formdata.append("tableType", 0);
        formdata.append("topicId", topiciid);
        formdata.append("state", 3);
        formdata.append("id", "");
        uploadzsxg(formdata).then((res) => {
          if (res.code == 200) {
            this.$message.success("证书上传成功");
            this.tabsbool[2].isshow = false;
          }
        });
      }
    }
  }
  // 暂存负责人内容
  saveprinci(type, datasource) {
    let topiciid = "";
    let params_: any = window.sessionStorage.getItem("topicid");
    if (JSON.parse(params_).topicId) {
      topiciid = JSON.parse(params_).topicId;
    } else {
      topiciid = JSON.parse(params_);
    }
    this[datasource].data.forEach((res) => {
      //  length=12是自己定义得id为时间戳 为了避免行内删除或者取消保存操作 兄弟对象受影响
      if (String(res.id).length == 13) {
        res.id = "";
      }
      res.isset = 0;
      res.topicid = topiciid;
    });
    let addparams: any = {
      state: 3,
    };
    if (type == 0) {
      addparams.majorTopicUpdateRequestList = this[datasource].data;
      addmajor(addparams).then((res) => {
        if (res.code === 200) {
          this.$message.success("负责人数据暂存成功");
          this.tabsbool[1].isshow = false;
        }
      });
    } else {
      addparams.expectationresearchAddRequests = this[datasource].data;
      addparams.expectationresearchAddRequests.forEach((res, index) => {
        res.num = index + 1;
      });
      addyqyjcg(addparams).then((res) => {
        if (res.code === 200) {
          this.$message.success("预期研究成果数据暂存成功");
        }
      });
    }
  }
  // 暂存经费预算
  savejfys(type) {
    let topiciid = "";
    let params_: any = window.sessionStorage.getItem("topicid");
    if (JSON.parse(params_).topicId) {
      topiciid = JSON.parse(params_).topicId;
    } else {
      topiciid = JSON.parse(params_);
    }
    this.allyearnum.data.forEach((res) => {
      res.isset = 0;
    });
    let addparam;
    // 正常新增
    if (type == 0) {
      addparam = {
        collect: this.budgetdata.data[1].money,
        counsel: this.budgetdata.data[3].money,
        descri: "",
        equipment: this.budgetdata.ptdata[0].money,
        id: this.budgetdata.id,
        itemList: this.allyearnum.data,
        material: this.budgetdata.data[0].money,
        other: this.budgetdata.data[6].money,
        publish: this.budgetdata.data[5].money,
        state: 3,
        topicid: topiciid,
        topmoney: "",
        sum: this.budgetdata.hjdata[0].money,
        travelling: this.budgetdata.data[2].money,
        type: 0,
        work: this.budgetdata.data[4].money,
      };
    }

    // 驳回预算后新增
    else {
      let newdatalist: any = [];
      if (this.allyearnum.data.length != 0) {
        this.allyearnum.data.forEach((res) => {
          let newobj = {
            id: "",
            money: res.money1,
          };
          newdatalist.push(newobj);
        });
      }

      addparam = {
        collect: this.budgetdata.data[1].money1,
        counsel: this.budgetdata.data[3].money1,
        descri: "",
        equipment: this.budgetdata.ptdata[0].money1,
        id: this.budgetdata.idupdate,
        itemList: newdatalist,
        material: this.budgetdata.data[0].money1,
        other: this.budgetdata.data[6].money1,
        publish: this.budgetdata.data[5].money1,
        state: 3,
        topicid: topiciid,
        topmoney: "",
        sum: this.budgetdata.hjdata[0].money1,
        travelling: this.budgetdata.data[2].money1,
        type: 1,
        work: this.budgetdata.data[4].money1,
      };
    }
    addbudget(addparam).then((res) => {
      if (res.code === 200) {
        this.$message.success("经费预算数据暂存成功");
      }
    });
  }
  // 暂存经费管理
  savejfgl() {
    let topiciid: any = "";
    let params_: any = window.sessionStorage.getItem("topicid");
    if (JSON.parse(params_).topicId) {
      topiciid = JSON.parse(params_).topicId;
    } else {
      topiciid = JSON.parse(params_);
    }
    this.jfysForm.topicid = topiciid;
    (this.$refs.jfysForm as any).validate((valid) => {
      if (valid) {
        addjfgl(this.jfysForm).then((res) => {
          if (res.code === 200) {
            this.$message.success("经费管理添加成功");
          }
        });
      } else {
        return false;
      }
    });
  }
  // 一键复制课题论证信息
  copektlz() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    getbasicsinfo(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          this.editor.ndktcontent = res.data.content;
        }
      }
    });
  }
  //暂存课题设计论证,课题基础及条件,课题论证活页
  savektlz(type) {
    let topiciid_ = "";
    let params_: any = window.sessionStorage.getItem("topicid");
    if (JSON.parse(params_).topicId) {
      topiciid_ = JSON.parse(params_).topicId;
    } else {
      topiciid_ = JSON.parse(params_);
    }
    let param: any = {
      id: this.editor.id,
      topicid: topiciid_,
      state: 3,
    };
    if (type == 0) {
      param.content = this.editor.content;
      adddesign(param).then((res) => {
        if (res.code === 200) {
          this.$message.success("课题设计论证数据暂存");
          this.tabsbool[3].isshow = false;
        }
      });
    } else if (type == 1) {
      param.content = this.editor.yjjccontent;
      addbasics(param).then((res) => {
        if (res.code === 200) {
          this.$message.success("研究基础及条件数据暂存");
          this.tabsbool[4].isshow = false;
        }
      });
    } else if (type == 2) {
      param.content = this.editor.ndktcontent;
      param.topicName = this.editor.topicName;
      (this.$refs.editorForm as any).validate((valid) => {
        if (valid) {
          addndktlz(param).then((res) => {
            if (res.code === 200) {
              this.$message.success("课题论证活页数据暂存成功");
            }
          });
        } else {
          return false;
        }
      });
    } else {
      param.content = this.editor.dwyjcontent;
      addopinion(param).then((res) => {
        if (res.code === 200) {
          this.$message.success("暂存单位意见成功");
        }
      });
    }
  }

  //获取数据表内容
  gettabledatinfo() {
    let userinfo = {
      name: "",
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    gettableinfo(userinfo).then((res) => {
      if (res.code === 200) {
        let data = res.data;
        if (data != null) {
          this.dataForm = data.topicdata;
          this.dataForm.topictype = data.topictype;
          this.dataForm.guideid = data.guideid;
          if (data.topicdata.administrative2 !== "") {
            this.tabledataobj.personshow = true;
          }
          this.dataForm.cooperativeInfoList = data.cooperativeList;
          this.dataForm.topicdatadetailList = data.topicdatadetailList;
          this.datatable.data = data.topicdatadetailList;
          this.partner.data = data.cooperativeList;

          // this.dataForm = JSON.parse(JSON.stringify(this.dataForm));

          this.copetabledata = _.clone(this.dataForm);
        }
      } else {
        this.$message.warning("查询错误");
      }
    });
  }

  // 获取经费预算内容
  getbudgetinfo() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    getbudgetinfo(userinfo).then((res) => {
      if (res.code === 200) {
        let data: any = {}; //未调整预算得数据  type=0
        let updatedata: any = {}; //调整预算后得数据   type=1
        if (res.data.length != 0) {
          res.data.forEach((res) => {
            if (res.type == 0) {
              data = res;
            } else {
              updatedata = res;
            }
          });
          let newArrays = Object.keys(data); //预算金额
          let newArraysUpdate = Object.keys(updatedata); //调整预算金额
          let newHandlearray2: any = [];
          let newHandlearray1: any = [];
          if (newArrays.length != 0) {
            data.itemList.forEach((res, i) => {
              let obj: any = {};
              obj.isset = 0;
              obj.year = res.year;
              obj.money = res.money;
              newHandlearray1.push(obj);
            });
            this.budgetdata.data[1].money = data.printingfee;
            this.budgetdata.data[3].money = data.postandtele;
            this.budgetdata.ptdata[0].money = data.equipment;
            this.budgetdata.id = data.id;
            this.budgetdata.data[0].money = data.officeexpenses;
            this.budgetdata.data[6].money = data.trainingfee;
            this.budgetdata.data[7].money = data.laborfee;
            this.budgetdata.data[8].money = data.othergoodsandservices;
            this.budgetdata.data[5].money = data.conferencefee;
            this.budgetdata.data[2].money = data.consultationfee;
            this.budgetdata.hjdata[0].money = data.sum;
            this.budgetdata.data[4].money = data.travelexpenses;
            // 调整预算内容
            if (updatedata.itemList != undefined) {
              if (updatedata.itemList.length > 0) {
                updatedata.itemList.forEach((res, i) => {
                  let obj: any = {};
                  obj.isset = 0;
                  obj.year = res.year;
                  obj.money1 = res.money;
                  newHandlearray2.push(obj);
                });
                // 将存放经费预算的数组内对象和存放调整经费预算的对象合并
                // array格式[{isset:0,year:'',moeny:'',money1:''}]
                var newhbarray = newHandlearray2.map((item, index) => {
                  return { ...item, ...newHandlearray1[index] };
                });
                for (let i in newhbarray) {
                  if (!newhbarray[i].money) {
                    newhbarray[i].money = "";
                  }
                }
                this.allyearnum.data = newhbarray;
                this.budgetdata.data[1].money1 = updatedata.printingfee;
                this.budgetdata.data[3].money1 = updatedata.postandtele;
                this.budgetdata.ptdata[0].money1 = updatedata.equipment;
                this.budgetdata.idupdate = updatedata.id;
                this.budgetdata.data[0].money1 = updatedata.officeexpenses;
                this.budgetdata.data[6].money1 = updatedata.trainingfee;
                this.budgetdata.data[7].money = data.laborfee;
                this.budgetdata.data[8].money = data.othergoodsandservices;
                this.budgetdata.data[5].money1 = updatedata.conferencefee;
                this.budgetdata.data[2].money1 = updatedata.consultationfee;
                this.budgetdata.hjdata[0].money1 = updatedata.sum;
                this.budgetdata.data[4].money1 = updatedata.travelexpenses;
              }
            } else {
              this.allyearnum.data = newHandlearray1;
            }
          } else {
            // 调整预算内容
            if (updatedata.itemList.length != 0) {
              updatedata.itemList.forEach((res, i) => {
                let obj: any = {};
                obj.isset = 0;
                obj.year = res.year;
                obj.money1 = res.money;
                newHandlearray2.push(obj);
              });
              for (let i in newHandlearray2) {
                if (!newHandlearray2[i].money) {
                  newHandlearray2[i].money = "";
                }
              }

              this.allyearnum.data = newHandlearray2;
              this.budgetdata.data[1].money1 = updatedata.printingfee;
              this.budgetdata.data[3].money1 = updatedata.postandtele;
              this.budgetdata.ptdata[0].money1 = updatedata.equipment;
              this.budgetdata.idupdate = updatedata.id;
              this.budgetdata.data[0].money1 = updatedata.officeexpenses;
              this.budgetdata.data[6].money1 = updatedata.trainingfee;
              this.budgetdata.data[7].money = updatedata.laborfee;
              this.budgetdata.data[8].money = updatedata.othergoodsandservices;
              this.budgetdata.data[5].money1 = updatedata.conferencefee;
              this.budgetdata.data[2].money1 = updatedata.consultationfee;
              this.budgetdata.hjdata[0].money1 = updatedata.sum;
              this.budgetdata.data[4].money1 = updatedata.travelexpenses;
            }
          }
        }
      }
    });
  }
  // 下载已上传的课题pdf
  handleWatch(row) {
    let index = row.loadPath.indexOf("=");
    let index_ = row.loadPath.indexOf("&");
    row.loadPath = row.loadPath.substring(index + 1, index_);
    var x = new XMLHttpRequest();
    // sbdata.url字符串前面的是完整版申报pdf 后面的是论证活页的pdf
    let href = this.baseurl + "/pdf/" + row.loadPath;
    window.open(href)
    // x.open("GET", href, true);
    // x.responseType = "arraybuffer";
    // x.onload = function (e) {
    //   var url = window.URL.createObjectURL(x.response);
    //   var a = document.createElement("a");
    //   a.href = url;
    //   if (row.fileName == null) {
    //     a.download = "课题附件";
    //   } else {
    //     a.download = row.fileName;
    //   }
    //   a.click();
    // };
    // x.send();
  }
  //  downloadfile(url, strFileName, strMimeType) {
  //   var xmlHttp = null;
  //   if (window.ActiveXObject) {
  //     // IE6, IE5 浏览器执行代码
  //     xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
  //   } else if (window.XMLHttpRequest) {
  //     // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
  //     xmlHttp = new XMLHttpRequest();
  //   }
  //   //2.如果实例化成功，就调用open（）方法：
  //   if (xmlHttp != null) {
  //     xmlHttp.open("get", url, true);
  //     xmlHttp.responseType = 'blob';//关键
  //     xmlHttp.send();
  //     xmlHttp.onreadystatechange = doResult; //设置回调函数
  //   }
  //   function doResult() {
  //     if (xmlHttp.readyState == 4) { //4表示执行完成
  //       if (xmlHttp.status == 200) { //200表示执行成功
  //         download(xmlHttp.response, strFileName, strMimeType);
  //       }
  //     }
  //   }
  // }
  // 获取负责人表内容，预期研究成果,经费管理，单位意见，课题论证活页
  getprincipalinfo(interficename, datasource) {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    interficename(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          res.data.forEach((item) => {
            if (item.isset == 0) {
              item.isset = false;
            } else {
              item.isset = true;
            }
          });
          this[datasource].data = res.data;
          this.copepricdata = _.clone(res.data);
        }
      }
    });
  }

  // 课题论证设计，研究基础及条件,经费管理，单位意见，课题论证活页
  getobjsinfo(interficename, datasource) {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid,
    };
    this.ktloading = true;
    this.ktloadingtitle = "数据正在加载中，请等待...";
    interficename(userinfo).then((res) => {
      if (res.code === 200) {
        this.ktloading = false;
        if (res.data != null) {
          this.editor[datasource] = res.data.content;
          this.editor.id = res.data.id; //3.9修改
          this.editor.topicName = res.data.topicname;
          // this.copetopicname = _.clone(res.data.topicname);
          this.copeobj = res.data.content;
        } else {
          if (datasource == "dwyjcontent") {
            this.editor[datasource] =
              "  申请书所填写的内容属实；该课题负责人及参加者的政治和业务素质适合承担本课题的研究工作；本单位能提供完成本课题所需的时间和条件；本单位同意承担本项目的管理任务和信誉保证。";
          } else {
            this.editor[datasource] = "";
          }
          this.copeobj = "";
        }
      }
    });
  }
  getktlzsj() {
    this.uploadData = []
    let param: any = {
      id: this.topicid,
      fileType: 0,
    };
    // fileType0 正常上传附件   1驳回预算后的附件   负值返回所有
    // isrefuse=true
    if (!this.isrefuse) {
      getktsjinfo(param).then((res) => {
        if(res.data.itemList.length > 0){
          this.uploadData = res.data.itemList;
          this.ruleForm.fileid = res.data.id;
        } 
      });
    } else {
      let paramys = {
        id: this.topicid,
        fileType: 1,
      };
      getktsjinfo(param).then((res) => {
        if(res.data.itemList.length > 0){
          this.uploadData = res.data.itemList;
          this.ruleForm.fileid = res.data.id;
        } 
      });
      getktsjinfo(paramys).then((res) => {
        if(res.data.itemList.length > 0){
          this.ysuploadData = res.data.itemList;
          this.ruleForm.fileid = res.data.id;
        } 
        // this.ysuploadData = res.data.itemList;
        // this.ruleForm.fileid = res.data.id;
      });
    }
  }
  // 获取相关证书info接口
  getciterinfo() {
    let userinfo = {
      id: this.topicid,
    };
    if (this.uploadobj.fileSizeIsSatisfy.length == 0) {
      getcertificateinfo(userinfo).then((res) => {
        if (res.code === 200) {
          if (res.data.id == null) {
            this.uploadid = "";
          } else {
            this.uploadid = res.data.id;
          }
          res.data.picList.forEach((item) => {
            item = this.basedownloadurl + item;
            this.uploadobj.fileSizeIsSatisfy.push({ url: item });
          });
          this.copefilelist = _.clone(this.uploadobj.fileSizeIsSatisfy);
        }
      });
    }
  }

  handleDeletetopic(index, row) {
    this.$confirm("确定删除这条数据吗, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.uploadData.splice(index, 1);
        let start = row.loadPath.indexOf("=");
        let end = row.loadPath.indexOf("&");
        row.loadPath = row.loadPath.substring(start + 1, end);
        let param = {
          fileName: row.fileName,
          filePath: row.filePath,
          fileSize: row.fileSize,
          id: this.ruleForm.fileid,
        };
        updatetopicfile(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
          }
        });
      })
      .catch(() => {});
  }
  handleRemovetopic() {}
  handlePreview(file) {}
  handleExceed(files, fileList) {
    this.$message.warning(
      `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`
    );
  }
  uploadtopic() {
    this.ruleForm.visible = true;
    this.ruleForm.filelist = [];
  }
  topicfilechange(file, filelist) {
    this.ruleForm.filelist.push(file);
  }
  uploadfile(type) {
    if (this.ruleForm.filelist.length == 0) {
      this.$message.warning("未选择文件，请选择后上传");
    } else {
      let formdata: any = new FormData();
      this.ruleForm.filelist.forEach((res) => {
        formdata.append("file", res.raw);
      });
      formdata.append("tableType", 1);
      formdata.append("topicId", this.topicid);
      formdata.append("state", 3);
      formdata.append("id", this.uploadid);
      if (type == 0) {
        formdata.append("fileType", 0);
      } else {
        formdata.append("fileType", 1);
      }
      uploadzsxg(formdata).then((res) => {
        if (res.code == 200) {
          this.$message.success("课题附件上传成功");
          this.ruleForm.visible = false;
          this.ruleForm.bhvisible = false;
          this.getktlzsj();
        }
      });
    }
  }
  agreetopic(param) {
    if (param == 0) {
      this.agreeform.agreevis = true;
    } else if (param == 1) {
      this.agreeform.refusevis = true;
    } else if(param === 2) {
      this.agreeform.refuseysvis = true;
    } else {
      this.agreeform.xswtgVis = true;
    }

  }
  closetopic() {
    this.$router.push({ path: "/tissuemanage/tissuemanage" });
  }
  agreetopicform(form, state) {
    let addparam: any = window.sessionStorage.getItem("topicinfo");
    let upaddparm = JSON.parse(addparam);
    let updateparam:any = {
      guideid: upaddparm.guideid,
      id: upaddparm.id,
      isdelete: upaddparm.isdelete,
      level: this.agreeform.level,
      num: upaddparm.num,
      state: state,
      fund: this.agreeform.fund,
      topicName: upaddparm.name,
      topictype: upaddparm.topictype,
      updatetime: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      userId: upaddparm.userid,
    };
    if (form == "refuse") {
      (this.$refs.refuseform as any).validate((valid) => {
        if (valid) {
          upaddparm.dismiss = this.agreeform.descri
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success("课题审批驳回")
              this.agreeform.agreevis = false;
              this.$router.push({ path: "/tissuemanage/tissuemanage" });
            }
          });
        } else {
          return false;
        }
      });
    }
    // 驳回经费预算
    else if (form == "refuseys") {
      (this.$refs.refuseysform as any).validate((valid) => {
        if (valid) {
          updateparam.dismiss = ''
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success("课题预算驳回");
              this.agreeform.refuseysvis = false;
              this.$router.push({ path: "/tissuemanage/tissuemanage" });
            }
          });
        } else {
          return false;
        }
      })
    }
    // 形审通过
    else if (form == "xstg"){
      (this.$refs.agreeform as any).validate((valid) => {
        if (valid) {
          updateparam.dismiss = ''
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success("课题级别绑定成功")
              this.agreeform.refuseysvis = false
              this.$router.push({ path: "/tissuemanage/tissuemanage" })
            }
          })
        } else {
          return false
        }
      });
    } else if(form === 'xswtg'){
      (this.$refs.xswtgForm as any).validate((valid) => {
        if (valid) {
          updateparam.dismiss = this.agreeform.xswtgDesc
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success("课题形审未通过");
              this.agreeform.refuseysvis = false;
              this.$router.push({ path: "/tissuemanage/tissuemanage" });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
  handledownload() {
    let formadata = new FormData()
    formadata.append("topicId", this.topicid)
    downloadfile(formadata).then((res) => {
      if (res.code == 200) {
        let href = this.baseurl + "/topicdatadetail/exp/outWord/1"
        const savea = document.createElement("a")
        // savea.download = "已填写的申报内容";
        savea.setAttribute("download", "下载内容")
        savea.href = href
        savea.click()
      }
    });
  }
}
